//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      icon: require("@/assets/image/icon/icon_pay_success.png"),
      objType:"",
      id:"",
      columnCode:"",
      payType:'',
      orderId:'',
      reUrl:null,
    };
  },
  methods: {
    backHome(){
      this.$routerHelper.goPageByThird('home',{
            columnCode: this.columnCode,
            id: this.id,
            objType:this.objType,
          })
    },
    showOrderDetail(){
        this.$routerHelper.goPageByThird('myBook',{
            columnCode: this.columnCode,
            id: this.id,
            objType:this.objType,
          })
    },
    pay(){
      let postD = {
        data: JSON.stringify({
            rawData: '',
            statusCode:0,//异常状态码
            client:'h5',
            type:this.payType,
            result:'0',//0成功，1失败 2取消 -3状态异常
            orderId:this.orderId,
            msg:'第三方支付成功'
          }),
      };
      this.GLOBAL_.ccRequest
        .doSessionAxios(this.CONFIG.H5BUY.PAY, postD, "POST")
        .then((res) => {
          // console.log(res);
          this.UTILS.hideLoading()
          if(this.reUrl && this.reUrl!='null'){
            console.log("reUrl",this.reUrl);
            setTimeout(() => {
                window.location.href = this.reUrl;
              }, 2000); // 2秒延时
          }
        })
        .catch((err) => {
          let errD = err.response.data;
          console.log("提交支付結果異常",errD.code,errD.message);
          this.UTILS.showToast(errD.message);
          this.UTILS.hideLoading();
        });
    },
  },
  mounted() {
      history.replaceState({}, '', '/');
      console.log(this.$route.query)
      this.objType = this.$route.query.objType || null;
      this.id = this.$route.query.id || null;
      this.columnCode = this.$route.query.columnCode || null;
      this.payType = this.$route.query.payType || null;
      this.orderId = this.$route.query.orderId || null;
      this.reUrl = this.$route.query.reUrl || null;
      console.log("mounted.reUrl",this.reUrl);
      if(this.orderId){
        this.pay()
      }
  },
};



// WEBPACK FOOTER //
// ./src/pages/buy/buySuccess.vue